module.exports = __webpack_public_path__ + "static/media/heat-stress-news.68f05099.jpg";